import { getStore } from '~/mobx/AppStore';

export const toggleCheckedRegionId = (id: string) => {
    const { regionStore } = getStore();

    if (regionStore.checkedRegionIds.includes(id)) {
        regionStore.setCheckedRegionIds(
            regionStore.checkedRegionIds.filter((checkedRegionId) => checkedRegionId !== id)
        );
    } else {
        regionStore.setCheckedRegionIds([...regionStore.checkedRegionIds, id]);
    }
};
